export default "__VITE_ASSET__JkWTNoKl__"